// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2fDvT","info":"UpdateTermsInfo_info__32yUx"};